const IF = require( "infrontjs" );

export class Api extends IF.Http
{
    constructor( endpoint )
    {
        // We are using version 1 for now
        super( IF.Helper.trim( endpoint, '/' ) + '/v1', { "Content-Type": "application/json"  } );
    }

    setSessionToken( token )
    {
        this.headers.set( 'x-sessiontoken', token );
    }

    deleteSessionToken()
    {
        this.headers.delete( 'x-sessiontoken' );
    }

    async _fetch( req, cb = null )
    {
        if ( cb )
        {
            fetch( req )
                .then( response => cb( null, response ) )
                .catch( error => cb( error, null ) );
        }
        else
        {
            let result = null;
            return await fetch( req );
        }
    }

}
